/*
 * ef-financing-dynamic.js (2026-07-15 v3) — minimal, high-end Shop Pay financing line.
 * v2 reproduced the wordy native sentence ("4 interest-free installments of $X, or from $Y/mo...").
 * Owner feedback: too much text, no breathing room. v3 renders ONE quiet line:
 *   "From $64/mo  [Shop Pay pill]  ·  See plans"
 * (falls back to "4× $174.75 interest-free" when only split-pay is offered for the price band).
 * Math unchanged from v2: reads shopify-meta financing_plans, amortization formula, ceil to $.
 * Works on configurator pages (live total via 'ef-cfg:price-changed') AND static PDPs
 * (data-price on .ef-fin-badge). Native component stays in DOM (visually hidden via snippet CSS)
 * so "See plans" can proxy its modal.
 */
(function () {
  var SHOP_PAY_SVG = '<svg width="56" height="16" viewBox="0 0 56 16" style="display:inline-block;vertical-align:-3px;" aria-label="Shop Pay" role="img"><rect width="56" height="16" rx="3.5" fill="#5A31F4"/><text x="28" y="11.3" text-anchor="middle" font-family="-apple-system,BlinkMacSystemFont,Segoe UI,sans-serif" font-size="9" font-weight="600" fill="#fff" letter-spacing=".3">Shop Pay</text></svg>';

  function init() {
    var badge = document.querySelector('.ef-fin-badge');
    if (!badge) return;
    var terms = badge.querySelector('shopify-payment-terms');
    if (!terms) return;

    var root = document.getElementById('efCfg');
    var basePrice = (root && parseInt(root.dataset.basePrice, 10)) || parseInt(badge.dataset.price, 10) || 0; // cents
    if (!basePrice) return;

    var meta;
    try { meta = JSON.parse(terms.getAttribute('shopify-meta') || ''); } catch (e) { return; }
    var plans = meta && meta.financing_plans;
    if (!plans || !plans.length) return;

    var cents = function (s) { return Math.round(parseFloat(String(s).replace(/[^0-9.]/g, '')) * 100) || 0; };
    var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

    function bandFor(total) {
      for (var i = 0; i < plans.length; i++) {
        if (total >= cents(plans[i].min_price) && total <= cents(plans[i].max_price)) return plans[i];
      }
      return null;
    }
    function monthly(principal, apr, n) {
      if (!apr) return Math.ceil(principal / n / 100) * 100;
      var r = apr / 100 / 12;
      var pmt = principal * r / (1 - Math.pow(1 + r, -n));
      return Math.ceil(pmt / 100) * 100;
    }

    /* Placement (owner feedback 2026-07-15): under the price the line read as a second,
       confusing "From ..." with zero context. High-end pattern: financing lives with the
       commitment moment — centered directly UNDER the Add to Cart button, prefixed with
       a plain-language label ("Pay over time") so it explains itself. */
    var custom = document.createElement('div');
    custom.className = 'ef-fin-badge__dyn';
    custom.style.cssText = 'width:100%;margin:12px 0 2px;font-size:12.5px;line-height:1.6;color:#6b6259;letter-spacing:.01em;display:flex;align-items:center;justify-content:center;gap:7px;flex-wrap:wrap;text-align:center;';
    /* Insert BELOW the whole button row (the ATC's flex container), never inside it —
       inserting next to the button squeezed the Back/Next nav (owner screenshot 2026-07-15). */
    /* Placement v4 (2026-07-15, decyzja Daniela): na konfiguratorze raty żyją POD
       TOTALEM w boxie ceny — jedna linia financingu, nie dwie. Fireplaces/static PDP:
       fallback bez zmian. */
    var totEl = document.getElementById('efCfgTotalPrice');
    var atc = document.getElementById('efCfgATC');
    var row = document.getElementById('efCfgNav') || (atc && atc.parentElement);
    if (totEl && totEl.parentElement) {
      custom.style.justifyContent = 'flex-start';
      custom.style.textAlign = 'left';
      custom.style.margin = '2px 0 8px';
      custom.style.fontSize = '12px';
      totEl.parentElement.insertAdjacentElement('afterend', custom);
    }
    /* v5 2026-08-12 (Daniel): fireplaces orderform — raty POD Totalem w boxie ceny, wzorzec doors */
    else if (document.getElementById('efOfTotal')) {
      custom.style.justifyContent = 'flex-start';
      custom.style.textAlign = 'left';
      custom.style.margin = '2px 0 2px';
      custom.style.fontSize = '12px';
      document.getElementById('efOfTotal').appendChild(custom);
    }
    else if (row && row.parentElement) row.insertAdjacentElement('afterend', custom);
    else { custom.style.justifyContent = 'flex-start'; custom.style.textAlign = 'left'; badge.appendChild(custom); }
    custom.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('ef-fin-badge__plans')) {
        e.preventDefault();
        var a = (terms.shadowRoot && terms.shadowRoot.querySelector('a,button,[role="button"]')) || terms.querySelector('a,button');
        if (a) a.click();
      }
    });
    var canOpenPlans = function () {
      return !!((terms.shadowRoot && terms.shadowRoot.querySelector('a,button,[role="button"]')) || terms.querySelector('a,button'));
    };

    function render(total) {
      var band = bandFor(total);
      if (!band) { custom.style.display = 'none'; return; }
      var split = null, interest = [];
      (band.terms || []).forEach(function (t) {
        if (t.loan_type === 'split_pay') split = t;
        else interest.push(t);
      });
      var main = '';
      if (interest.length) {
        var best = null;
        interest.forEach(function (t) { var m = monthly(total, t.apr, t.installments_count); if (!best || m < best) best = m; });
        main = 'Pay over time &mdash; as low as <strong style="font-weight:600;color:#3A3732;">' + money(best) + '/mo</strong> with';
      } else if (split) {
        main = 'Pay over time &mdash; ' + split.installments_count + ' interest-free payments of <strong style="font-weight:600;color:#3A3732;">' + money(Math.round(total / split.installments_count)) + '</strong> with';
      } else { custom.style.display = 'none'; return; }

      var html = '<span>' + main + '</span>' + SHOP_PAY_SVG;
      if (canOpenPlans()) html += '<span style="color:#c9c2b8">&middot;</span><a href="#" class="ef-fin-badge__plans" style="color:#8A6A43;text-decoration:none;border-bottom:1px solid #d8cbb8;padding-bottom:1px;">See plans</a>';
      custom.innerHTML = html;
      custom.style.display = 'flex';
    }

    render(basePrice);
    window.addEventListener('ef-cfg:price-changed', function (e) {
      var t = e && e.detail && e.detail.totalCents;
      if (typeof t === 'number' && t > 0) render(t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
